var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTextfieldEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 6.14829L3.82667 4.66663L23.3333 24.1733L21.8517 25.6666L18.2583 22.0733C16.9167 22.5166 15.4933 22.75 14 22.75C8.16667 22.75 3.185 19.1216 1.16667 14C1.97167 11.9466 3.255 10.1383 4.88833 8.70329L2.33333 6.14829ZM14 10.5C14.9283 10.5 15.8185 10.8687 16.4749 11.5251C17.1313 12.1815 17.5 13.0717 17.5 14C17.5006 14.3973 17.4335 14.7918 17.3017 15.1666L12.8333 10.6983C13.2081 10.5664 13.6027 10.4994 14 10.5ZM14 5.24996C19.8333 5.24996 24.815 8.87829 26.8333 14C25.8812 16.4187 24.2631 18.5181 22.1667 20.055L20.51 18.3866C22.1234 17.2706 23.4246 15.7605 24.29 14C23.3468 12.0749 21.8825 10.453 20.0635 9.31872C18.2445 8.18441 16.1437 7.58315 14 7.58329C12.7283 7.58329 11.48 7.79329 10.3133 8.16663L8.51667 6.38163C10.1967 5.65829 12.0517 5.24996 14 5.24996ZM3.71 14C4.65318 15.925 6.1175 17.5469 7.93652 18.6812C9.75554 19.8155 11.8563 20.4168 14 20.4166C14.805 20.4166 15.5983 20.335 16.3333 20.1716L13.6733 17.5C12.8615 17.4129 12.104 17.0506 11.5266 16.4733C10.9493 15.896 10.587 15.1384 10.5 14.3266L6.53333 10.3483C5.37833 11.34 4.41 12.5766 3.71 14Z",
    fill: "#A7ACB1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTextfieldEye);
export default __webpack_public_path__ + "static/media/icon-textfield-eye.61789a1d7b116481783ce26f4745eeea.svg";
export { ForwardRef as ReactComponent };